// Only matches the beginning of the label or value (country code)
export const filterCountries = ({ label, value }, searchText) => {
	if (
		label.toLowerCase().startsWith(searchText.toLowerCase()) ||
		value.toLowerCase().startsWith(searchText.toLowerCase())
	) {
		return true;
	}
	return false;
};
